import React from 'react';
import CiberIsgcontent from '../components/CiberIsgContent';
import Footer from '../components/footer';

const CiberIsgpage = () => {
  return (
    <div className="Ciberseg">
         
          <CiberIsgcontent />
          <Footer />
    </div>
  );
}

export default CiberIsgpage;